export default __webpack_public_path__ + "static/media/movie-hub.173b9055.png";